import React from "react";
import { BulkModalProvider } from "./BulkModalProvider.js";
import { Modal } from "./Modal.js";
import { ModalContext } from "./types.js";
const ModalProvider = ({ children }) => {
  const [isModalOpened, setIsModalOpened] = React.useState(false);
  const [modalContent, setModalContent] = React.useState(null);
  const openModal = (content) => {
    setModalContent(content);
    setIsModalOpened(true);
  };
  const closeModal = () => {
    setModalContent(null);
    setIsModalOpened(false);
  };
  return /* @__PURE__ */ React.createElement(ModalContext.Provider, { value: { isModalOpened, modalContent, openModal, closeModal } }, /* @__PURE__ */ React.createElement(BulkModalProvider, null, children, /* @__PURE__ */ React.createElement(Modal, null)));
};
export {
  ModalProvider
};
//# sourceMappingURL=ModalProvider.js.map
